var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
var DataService = /** @class */ (function () {
    function DataService(http) {
        this.http = http;
    }
    DataService.prototype.getCountryCodeJSON = function () {
        return this.http.get('assets/jsonFiles/countryCode.json')
            .map(function (res) { return res.json(); });
    };
    DataService.prototype.getCountryJSON = function () {
        return this.http.get('assets/jsonFiles/countries.json')
            .map(function (res) { return res.json(); });
    };
    DataService.prototype.getLanguageJSON = function () {
        return this.http.get('assets/jsonFiles/language.json')
            .map(function (res) { return res.json(); });
    };
    DataService.prototype.getTimeZoneJSON = function () {
        return this.http.get('assets/jsonFiles/Timezone.json')
            .map(function (res) { return res.json(); });
    };
    DataService.prototype.getTaskStatusJSON = function () {
        return this.http.get('assets/jsonFiles/TaskStatus.json')
            .map(function (res) { return res.json(); });
    };
    DataService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Http])
    ], DataService);
    return DataService;
}());
export { DataService };



//////////////////
// WEBPACK FOOTER
// ./src/app/settings/data.service.ts
// module id = ./src/app/settings/data.service.ts
// module chunks = main